import { get, post } from "../util/axiosConfig";


// 获取学科、课程版本、年级
export const getCategory = params => get("/express/getCategory", params)
// 获取测试id
export const getToken = params => get("/express/startTest", params)
